import React, { Component } from "react";
import Appbar from "./appbar";
import Footer from "./footer";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

export default class Faqs extends Component {
  constructor(props) {
    super(props);
    this.state ={
      openAccrodion:null
    }
  }

  handleAccordion = (label) => () => {
    const {openAccrodion} = this.state;
    if(parseFloat(openAccrodion) === parseFloat(label)){
      console.log("hello babai")
      this.setState ({
        openAccrodion:null
      })
    }else {
      this.setState ({
        openAccrodion:label
      })
    }
  }
  render() {
    const qa = [
      {
        q: "1. What is ENACH Mandate?",
        a: "E-NACH Mandate is electronic mandate which has been a recent entrant into the mutual fund investment process, in a bid to make the entire investment process digital and paperless.",
      },
      {
        q: "2. How to register ENACH Mandate?",
        a: "Investors will need to login into their transact online account and select the ENACH mandate registration option. The self-help mechanism will help complete the registrations process swiftly.",
      },
      {
        q: "3. How many days it will take to register ENACH Mandate?",
        a: "The process is instant; however, it can get delayed due to any technical issue at the bank’s end or NPCI site. The entire process whether successfully registered or not, generally, will not take more than one business day.",
      },
      {
        q: "4. Where I can check my ENACH mandate status?  ",
        a: "You can check ENACH mandate status under ENACH Registration Summary.",
      },
      {
        q: "5. How many SIPS we can register through ENACH Mandate?",
        a: "You can register multiple sips by selecting UMRN under ENACH Registration Summary.",
      },
      {
        q: "6. Can I do Change of bank of my ENACH Mandate?",
        a: "You cannot do change of bank of registered ENACH Mandate, you have to cancel the existing ENACH mandate and will need to register New ENACH Mandate. Also note that the SIPs registered under the Mandate will stand terminated as soon as the Mandate is cancelled.",
      },
      {
        q: "7. Can I register ENACH mandate through any bank?",
        a:"",
      },
      {
        q: "8. Can I register ENACH mandate through Current A/c?",
        a: "No. Presently registration is allowed only though Savings bank A/c.",
      },
      {
        q: "9. When I can register my SIP after registering ENACH Mandate?",
        a: "Once ENACH mandate gets registered, immediately you can register SIP which can start only after 10 days.",
      },
    ];
    const {openAccrodion} = this.state
    return (
      <div className="main-terms-conditions">
        <Appbar center={true} />
        <div className="scroll-term">
          <div className="faqs">
            <div className="faqs-title">FAQs</div>
            <div className="faqs-subtitle">
              Kindly click on respective question for details.
            </div>

            <div className="faqs-accordion">
              {qa.map((ele, index) =>
                index === 6 ? (
                  <Accordion
                  expanded={parseFloat(openAccrodion) === parseFloat(index)}
                  onChange={this.handleAccordion(index)}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      {ele.q}
                    </AccordionSummary>
                    <AccordionDetails>
                      <ul className="title-class">
                      <div style={{} } >Currently the facility is available for select few banks. You can register ENACH mandate through below banks:</div>
                     <li> Axis Bank </li>
                     <li>AU Small Finance Bank Ltd</li>
                     <li>Bank of Maharashtrali</li>
                     <li>Bank of Barodali</li>
                     <li>Bandhan Bank Ltd</li>
                     <li>Citibank</li>
                     <li>Central Bank of India</li>
                     <li>City Union Bank Ltd</li>
                     <li>Canara Bank</li>
                     <li>Deutsche Bank</li>
                     <li>Dhanalaxmi Bank</li>
                     <li>DBSB Bank India Ltd</li>
                     <li>DCB Bank Ltd</li>
                     <li>Equitas Small Finance Bank Ltd</li>
                     <li>Federal Bank</li>
                     <li>HDFC Bank Ltd</li>
                     <li>IDFC First Bank Ltd</li>
                     <li>Indusind Bank</li>
                     <li>ICICI Bank Ltd</li>
                     <li>IDBI Bank</li>
                     <li>Indian Overseas Bank</li>
                     <li>Indian Bank</li>
                     <li>Jana Small Finance Bank Ltd</li>
                     <li>JIO Payments Bank Ltd</li>
                     <li>Kotak Mahindra Bank Ltd</li>
                     <li>Karnataka Bank Ltd</li>
                     <li>Karur Vysya Bank</li>
                     <li>Punjab National Bank</li>
                     <li>PayTM Payments Bank Ltd</li>
                     <li>Punjab and Sind Bank</li>
                     <li>RBL Bank Ltd</li>
                     <li>South Indian Bank</li>
                     <li>State Bank of India</li>
                     <li>Standard Chartered Bank</li>
                     <li>Tamilnad Mercantile Bank Ltd</li>
                     <li>The Hongkong and Shanghai Banking Corporation Ltd</li>
                     <li>The Cosmos Co-operative Bank Ltd</li>
                     <li>Ujjivan Small Finance Bank Ltd</li>
                     <li>Union Bank of India</li>
                     <li>UCO Bank</li>
                     <li>Yes Bank</li>
                      </ul>
                    </AccordionDetails>
                  </Accordion>
                ) : (
                  <Accordion
                  expanded={parseFloat(openAccrodion) === parseFloat(index)}
                  onChange={this.handleAccordion(index)}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      {ele.q}
                    </AccordionSummary>
                    <AccordionDetails>{ele.a}</AccordionDetails>
                  </Accordion>
                )
              )}
            </div>

          <div className="disclamier">
          <span>Disclaimers & Risk Factors:</span> This FAQ is prepared based on the understanding "How to Transact Online" for Subscription of Units of various Schemes of BAJAJ MUTUAL FUND. This information is meant for general reading purposes only and is not meant to serve as a professional guide for the readers. The Sponsor, the Investment Manager, the Trustee or any of their respective directors, employees, affiliates or representatives do not assume any responsibility for, or warrant the accuracy, completeness, adequacy and reliability of such information. Whilst no action has been solicited based upon the information provided herein, due care has been taken to ensure that the facts are accurate and opinions given are fair and reasonable. This information is not intended to be an offer or solicitation for the purchase or sale of any financial product or instrument. Readers are advised to seek independent professional advice, verify the contents and arrive at an informed investment decision before making any investments. None of the Sponsor, the Investment Manager, the Trustee, their respective directors, employees, affiliates or representatives shall be liable for any direct, indirect, special, incidental, consequential, punitive or exemplary damages, including lost profits arising in any way from the information contained in this material.
          </div>

          <div className="disclamier">

          <span> Statutory Details:</span> BAJAJ MUTUAL FUND has been constituted as a trust in accordance with the provisions of the Indian Trusts Act, 1882. Sponsor: Mirae Asset Global Investments Company Limited-Seoul, Korea; Investment Manager: Mirae Asset Global Investments (India) Private Limited; Trustee: Mirae Asset Trustee Company Private Limited. The Sponsor, the Trustee and the Investment Manager are incorporated under the Companies Act 1956. The sponsors are not liable or responsible for any loss resulting from the operation of the fund beyond the initial contribution made by them of an aggregate amount of Rupees One Lakh towards setting up of the fund.
          </div>

          <div className="disclamier">

          Mutual fund investments are subject to market risks and there is no assurance or guarantee that the objectives of the scheme will be achieved. As with any investment in securities, the Net Asset Value (NAV) of the units issued under the Schemes can go up or down depending on the factors and forces affecting the capital markets. Investments in mutual funds are prone to risks of fluctuation in NAVs, uncertainty of dividend distributions etc. Past performance of the Sponsor / AMC / Mutual Fund / Trustee does not indicate the future performance of the Schemes of BAJAJ MUTUAL FUND. Please read the respective Scheme Information Document for scheme specific details. Unit holders in the Scheme are not being offered any guaranteed / assured returns. A copy of SAI / SID / Key Information Memorandum cum Application form will be available at AMC offices / AMC website <a href="https://www.miraeassetmf.co.in/" target="_blank"> www.miraeassetmf.co.in</a> / Investor Service Centre / Distributors on request.
          </div>

          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
